module.exports = __webpack_public_path__ + "static/example_week_weekdays_only-450110f53608b76b126eb12a165ebea2.png";